import styled, { css } from 'styled-components';
import { ViewMode } from '@/app/common/viewModeUtils';
import { focusRing } from '@/app/components/search/styles/mixins.ts';
import { LISTVIEW_SIDEBAR_WIDTH_LARGE } from '../../../../styles/constants';

export const ViewModeButton = styled.button<{ disabled: boolean; viewMode: ViewMode }>`
  border: 0;
  background: #ffffff;
  box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.mediumDownShadow};
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
  padding: 10px 16px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  cursor: pointer;
  transition:
    color 0.2s ease,
    box-shadow 0.2s ease-out;

  ${({ viewMode }) =>
    viewMode === ViewMode.MAP
      ? css`
          margin-left: 24px;
        `
      : css``};

  &:hover {
    box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.mediumDownShadow};
  }

  &:active {
    box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.largeDownShadow};
  }

  &:focus-visible {
    border-radius: 2px;
    ${focusRing}
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${({ theme }) => theme.kallisto.color.common.black[200]};
      box-shadow: none !important;
      cursor: default;
    `}
`;

export const ViewModeContainer = styled.div<{
  bg: string;
  viewMode: ViewMode;
  sustainabilityEnabled?: boolean;
  externalHeaderEnabled: boolean;
}>`
  display: flex;
  height: 56px;
  width: 240px;
  position: relative;
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
  flex-shrink: 0;

  @media (max-width: 1023px) {
    visibility: hidden;
    opacity: 0;
    width: 0;
    margin-right: 0;
  }

  @media (min-width: 1024px) {
    height: 56px;
  }

  ${({ viewMode, externalHeaderEnabled }) =>
    viewMode === ViewMode.MAP
      ? css`
          width: auto;

          @media (min-width: 1024px) {
            height: 72px;

            ${
              externalHeaderEnabled &&
              `
              margin-right: 15px;
            `
            }
          }

          &:after {
            content: '';
            width: 1px;
            height: 24px;
            right: -8px;
            background-color: ${({ theme }) => theme.kallisto.color.common.black[100]};
            margin: 0 13px 0 16px; // 15px margin to the right to compensate for extra margin on pill

            ${externalHeaderEnabled && `width: 0px;`}
          }

          @media (min-width: 1200px) {
            height: 72px;
          }
        `
      : css`
          justify-content: center;
          width: ${LISTVIEW_SIDEBAR_WIDTH_LARGE};
          max-width: 100%;
          border: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
        `};

  ${({ bg }) =>
    bg &&
    css`
      background-image: url(${bg});
      background-position-x: right;
      background-size: cover;
    `};
`;
